import type { TFunction } from 'i18next';

/**
 * Type-narrowed `t` call for **dynamic** keys (e.g. built via template
 * literals, resolved from a manifest, or read off a route handle).
 *
 * Literal-key lookups should go through `t(...)` directly so TypeScript
 * can validate that the key exists in the i18n resources. This helper
 * exists only for the handful of genuinely dynamic callers; pushing the
 * cast into one location makes the tradeoff explicit instead of
 * sprinkling `as never` through the app.
 */
export function tDynamic(t: TFunction, key: string, options?: Record<string, unknown>): string {
  return options === undefined
    ? (t as (k: string) => string)(key)
    : (t as (k: string, o: Record<string, unknown>) => string)(key, options);
}
